// extracted by mini-css-extract-plugin
export default {"imgdiv":"_9b67d805ef a07844c57d","img":"_4f835b4dd2 _16b8b68442"};